import TagManager from 'react-gtm-module'
import { canUseDOM } from 'utils'
import { checkPreviousPageExists, setPreviousPageExists } from './webStorage'
import getConstants from './../constants'
import { BRAND_LIST } from 'typings'

const getPageViewData = (ifPreviousPageExists: boolean = false): any => {
  const brand = getConstants().BRAND
  return {
    dataLayer: {
      event: 'trackPageView',
      brand: brand === BRAND_LIST.PL ? brand.toUpperCase() : brand,
      pageType: 'Storelocator',
      pageUrlPath: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      pageTitle: document.title,
      previousPageExists: ifPreviousPageExists,
    },
  }
}

export const sendPageViewData = () => {
  if (!canUseDOM || !TagManager.dataLayer) {
    return
  }
  const ifPreviousPageExists = checkPreviousPageExists()
  TagManager.dataLayer(getPageViewData(ifPreviousPageExists))
  setPreviousPageExists('Storelocator')
}
